import React, { useEffect, useState } from "react";
import { Form, Link, NavLink, useNavigate } from "react-router-dom";
import FloatingLabelInput from "./FloatingLabelInput"; // Adjust the import path
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { SignInImages, people } from "../config/imagesLink"; 
import axios, { PublicKey } from "../API/axios";
import { completeLoginNotificationFetch } from "../Services/apiService";
import { GA_MEASUREMENT_ID } from "../config/appConfig";
import fetch_axios from "axios";
import { useFormik } from "formik";
import { loginValidations } from "./Validations";
import { useGoogleLogin } from "@react-oauth/google";
import LeftNavigation from "./Navigation/LeftNavigation";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import TranslateIcon from '@mui/icons-material/Translate';
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";
import i18n from "../i18n";
import { Dropdown } from "react-bootstrap";

const shouldEnableFirebaseAnalytics = (() => {
  if (process.env.NODE_ENV !== "production") return false;
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  
  const isProdHost =
    host === "welinkjobs.com" ||
    (host.endsWith(".welinkjobs.com") && !host.startsWith("preprod."));
   return isProdHost;
 })();

 const firebaseConfig = {
  apiKey: "AIzaSyD8GJvS-To2H4dOM8lbn5JRUQVhCL8uxJM",
  authDomain: "welinkjobs-23583.firebaseapp.com",
  projectId: "welinkjobs-23583",
  storageBucket: "welinkjobs-23583.appspot.com",
  messagingSenderId: "375220227786",
  appId: "1:375220227786:web:bb1fd63622ce66d4936e33",
  ...(shouldEnableFirebaseAnalytics
    ? { measurementId: GA_MEASUREMENT_ID }
    : {}),
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

 const SignIn = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState("false");
  const language = localStorage.getItem("Lang");


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [sessionId, setSessionId] = useState(""); 
  const [User_Name, setuserName] = useState("");
  const [confimAcc, setconfirmAcc] = useState("");
  const [Response_Message, setmessage] = useState("");
  const [userID, setuserID] = useState("");
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n?.language || localStorage.getItem("Lang") || "en");
  const handleChangeOtp = (otp) => setOtp(otp);
  const getApiMessage = (error, fallback = "Login failed") =>
    error?.response?.data?.message || error?.message || fallback;
  const getResponseMessage = (res, fallback = "Login failed") =>
    res?.data?.message || fallback;
  const isLoginSuccessResponse = (res) =>
    res?.data?.status === "Success" &&
    res?.data?.responseData &&
    res?.data?.responseData?.profile;
  const resetToasts = () => {
    setShowToast(false);
    setToastMessage("");
    setShowWarningToast(false);
    setWarningToastMessage("");
    setShowErrorToast(false);
    setErrorToastMessage("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [loading, setLoading] = useState(false);
  const [loadOTP, setLoadOTP] = useState(false);
  const initialValues = {
    email: localStorage.getItem("user-email") || "",
    password: "",
  };

  const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: loginValidations,
      onSubmit: async () => {
        setLoading(true);
        resetToasts();
        const RegisterData = {
          deviceType: "Web",
          email: values.email,
          password: values.password,
          langKey: language === "en" ? "" : language,
        };
        try {
          const res = await axios.post("OAuth/LoginWithEmail", RegisterData, {
            headers: {
              PublicKey,
            },
          }); 
          if (!isLoginSuccessResponse(res)) {
            setErrorToastMessage(getResponseMessage(res));
            setShowErrorToast(true);
            return;
          }
          const response = res.data.responseData.profile;
          const algoData = res.data.responseData.algoData;
          const userRole = res.data.responseData.userRoles;
          setToastMessage(res.data.message);
          setShowToast(true);
          // localStorage.setItem("user-Id", response.id); 
          localStorage.setItem("Lang", language === null ? "en" : language);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);
          localStorage.setItem("CheckNotifyId", response.id);

          localStorage.setItem("engagedUsersMostEngagedPostIds", algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          // setTimeout(() => {
          // }, 500);
        } catch (error) {
          const errorMessage = getApiMessage(error);
          setShowToast(false);
          setToastMessage("");
          setShowWarningToast(false);
          setWarningToastMessage("");
          if (error.response && error.response.status === 403) {
          console.log("loginconfirm", error.response.data.responseData.accountConfirmed);

            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
            setFlag(true);
            setuserName(error.response.data.responseData.userName);
            setconfirmAcc(error.response.data.responseData.accountConfirmed);
            setmessage(errorMessage);
            setSessionId(error.response.data.responseData.sessionID);
            setuserID(error.response.data.responseData.userId);
          } else if (error.response && error.response.status === 404) {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
          } else {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
            setTimeout(() => {
              if (errorMessage === "Account not confirmed!") {
                navigate("/ConfirmAccount");
              }
            }, 2000);
          }
        } finally {
          setLoading(false);
        }
      },
    });

  const externalLogin = async (responseData) => {
    resetToasts();
    try {
      const res = await axios.post("OAuth/LoginWithGoogle", responseData, {
        headers: {
          PublicKey,
        },
      });
      if (!isLoginSuccessResponse(res)) {
        setErrorToastMessage(getResponseMessage(res));
        setShowErrorToast(true);
        return;
      }
      console.log("login", res.data.responseData);
      localStorage.setItem("Lang", language === null ? "en" : language);
      const data = res.data.responseData;
      const response = res.data.responseData.profile;
      const userRole = res.data.responseData.userRoles;
      // toast.success("Login successful!");
      setToastMessage(res.data.message);
      setShowToast(true);
      localStorage.setItem("Lang", language === null ? "en" : language);
      localStorage.setItem("user-Id", response.id);
      localStorage.setItem("userUid", response.userUid);
      localStorage.setItem("user-email", response.email);
      localStorage.setItem("user-nameTag", response.nameTag);
      localStorage.setItem("user-profilPic", response.profilPic);
      localStorage.setItem("user-referCode", response.referCode);
      localStorage.setItem("sessionId", response.sessionId);
      localStorage.setItem("token", response.token);
      localStorage.setItem("loginType", response.loginType);
      localStorage.setItem("profilPic", response.profilPic);
      localStorage.setItem("firstName", response.firstName);
      localStorage.setItem("lastName", response.lastName);
      localStorage.setItem("userRole", userRole);
          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)


      localStorage.removeItem("guestMode");
      await completeLoginNotificationFetch();
      navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
      // localStorage.setItem("guestMode", "false");
    } catch (error) {
      const errorMessage = getApiMessage(error);
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 403) {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setFlag(true);
        setconfirmAcc(error.response.data.responseData.accountConfirmed);
        setuserName(error.response.data.responseData.userName);
        setSessionId(error.response.data.responseData.sessionID);
        setuserID(error.response.data.responseData.userId);
      } else if (error.response && error.response.status === 404) {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setTimeout(() => {
          if (errorMessage === "Account not confirmed!") {
            navigate("/ConfirmAccount");
          }
        }, 2000);
      }
    }
  };
  const otpCheck = async (e) => {
setLoadOTP(true);
    e.preventDefault();
    resetToasts();
    try {
      await axios
        .post(
          `OAuth/LoginByOTPFor2FA?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web&LangKey=${language}`, 
        )
        .then(async (res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setLoadOTP(false);
          setShowToast(true);
          setFlag(false);

          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          setToastMessage(res.data.message);
          setShowToast(true);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          setTimeout(() => {
            navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          }, 1000);
          // setTimeout(() => {
          //   navigate("/SignIn");
          // }, 2000);


          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
          setLoadOTP(false);

      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
          setLoadOTP(false);

      }
    }
  };

  const ConfirmotpCheck = async (e) => {
    e.preventDefault();
    resetToasts();
    try { 
      await axios
        .post(
          `OAuth/ConfirmAccountByOTP?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web`,
          { headers: { PublicKey } }
        )

        .then(async (res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setShowToast(true);
          setFlag(false);

          const data = res.data.responseData;
          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          localStorage.setItem("Lang", language === null ? "en" : language);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();

          setTimeout(() => {
            navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          }, 2000);
          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const googleSignin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const resp = await fetch_axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const responseData = {
          deviceType: "Web",
          email: resp.data.email,
          externalLoginId: resp.data.sub,
          loginType: "Google",
          firstName: resp.data.given_name,
          lastName: resp.data.family_name,
        };
        externalLogin(responseData);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const [guestMode, setGuestMode] = useState(false);
  const activateGuestMode = () => {
    setGuestMode(true);
    navigate("/NewsFeed");
    localStorage.setItem("guestMode", "true");
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [originalemail, setOriginalEmail] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [externalEmail, setExernalEmail] = useState("");

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
 
  const _loginWithApple = async (accessToken) => {
    resetToasts();
    try {
      const responseData = {
        deviceType: "Web",
        appleAccessToken: accessToken,
        loginType: "Apple",
        langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("OAuth/LoginWithApple", responseData, {
        headers: {
          PublicKey,
        },
      });
      if (!isLoginSuccessResponse(res)) {
        setErrorToastMessage(getResponseMessage(res));
        setShowErrorToast(true);
        return;
      }

      console.log("login", res.data.responseData);
        localStorage.setItem("Lang", language === null ? "en" : language);

      const data = res.data.responseData;
      const response = res.data.responseData.profile;
      const userRole = res.data.responseData.userRoles;
      setToastMessage(res.data.message);
      setShowToast(true);
      localStorage.setItem("Lang", language === null ? "en" : language);
      localStorage.setItem("user-Id", response.id);
      localStorage.setItem("userUid", response.userUid);
      localStorage.setItem("user-email", response.email);
      localStorage.setItem("user-nameTag", response.nameTag);
      localStorage.setItem("user-profilPic", response.profilPic);
      localStorage.setItem("user-referCode", response.referCode);
      localStorage.setItem("sessionId", response.sessionId);
      localStorage.setItem("token", response.token);
      localStorage.setItem("loginType", response.loginType);
      localStorage.setItem("profilPic", response.profilPic);
      localStorage.setItem("firstName", response.firstName);
      localStorage.setItem("lastName", response.lastName);
      localStorage.setItem("userRole", userRole);

          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

      localStorage.removeItem("guestMode");
      await completeLoginNotificationFetch();
      navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
      // localStorage.setItem("guestMode", "false");
    } catch (error) {
      console.error("Error during registration:", error);
      const errorMessage = getApiMessage(error);
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (errorMessage === 'User account already exists with associated email address, but not confirmed yet. Please confirm your account and login') {
        setFlag(true)
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setconfirmAcc(error.response.data.responseData.accountConfirmed);
        setuserName(error.response.data.responseData.userName);
        setSessionId(error.response.data.responseData.sessionID); 
        setuserID(error.response.data.responseData.userId);

      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };
  const signInWithApple = async () => {
    const provider = new OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log(user.accessToken);
      setFirstName(user.displayName?.split(" ")[0]);
      setLastName(user.displayName?.split(" ")[1]);
      setExernalEmail(user.email);
      setAccessToken(user.accessToken);
      setPhotoUrl(user.photoURL);
      _loginWithApple(user.accessToken);
    } catch (error) {
      console.error("Error signing in with Apple:", error);
    }
  };

  const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
  const ConnectionListAllForGuest = async (id) => {
    try {
      await axios
        .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
        .then((resData) => { 
          setConnectionListForGuest(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // console.log('ConnectionListForGuest', ConnectionListForGuest);

  useEffect(() => {
    ConnectionListAllForGuest();
  }, []);

  const LinktoGuest = () => {
    setGuestMode(true);
    localStorage.setItem("guestMode", "true");
  };

  const [minutes, setMinutes] = useState(1)
  const [seconds, setSeconds] = useState(30)

  const Resend2FAOTP = async (e) => {
    if (seconds > 0 || minutes > 0) return;
    setMinutes(1);
    setSeconds(30);
    e.preventDefault();
    try {
      await axios
        .post(
          `OAuth/Resend2FAOTP?UserID=${userID}`
        )
        .then((res) => {
          console.log("res", res);
          setSessionId(res.data.responseData.sessionID);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  }; 

  const resendOTP = async (e) => {
      if (seconds > 0 || minutes > 0) return;
      setMinutes(1);
      setSeconds(30);
      e.preventDefault();
      try {
        await axios.post(`OAuth/ResendOTP?UserID=${userID}`).then((res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setShowToast(true);
            setSessionId(res.data.responseData.sessionID);

        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (showModal || flag) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [showModal, flag]);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("Lang", lang);
    setCurrentLang(lang);
    // document.body.dir = lang === "ar" ? "rtl" : "ltr"; // RTL for Arabic
  };

  return (
    <>
      <style>
        {
          `.language-dropdown .dropdown-menu {
            transform: none !important;
            inset: auto !important;
            right: 10px !important;
            bottom: 40px !important;
    }
`
        }
      </style>
      <div className="container-fluid">
        <div className="row non-login-main">
          <div className="col-lg-8 col-md-6 full-height p-2 loginImage">
            <div className="bg-cover">
              <div className="imageData">
                <div className="text-center">
                  <img src={SignInImages.whiteLogo} alt="" />
                </div>
                <p>
                  {t("SignIn.Stay connected for")} <NavLink
                    to={`/SearchJob`}
                    onClick={LinktoGuest}
                    className="border-bottom"
                  >
                    {t("Company Profile.Jobs")}

                  </NavLink> {t("SignIn.and")} <NavLink
                    to={`/NewsFeed`}
                    onClick={LinktoGuest}
                    className="border-bottom"
                  >
                    {t("SignIn.More")}

                  </NavLink>
                </p>
                <div className="userLink text-center mt-2 d-flex justify-content-center">
                  <Link to="/People" onClick={LinktoGuest}>
                    <div className="circle-container">
                      {ConnectionListForGuest &&
                        ConnectionListForGuest?.slice(0, 3).map(
                          (user, userIndex) => (
                            <img
                              src={user?.profilPic}
                              alt={`Circle ${userIndex + 1}`}
                              className="circle-img"
                              key={userIndex}
                              onError={handleProfileImageError}
                            />
                          )
                        )}
                    </div>
                  </Link>
                  <span className="f-14 fw-bold">
                    {t("SignIn.15k+ people joined us, now it's your turn")}
                  </span>

                  {/* <img src={SignInImages.ovalwithtext} alt="" width="80%" /> */}
                </div>
                <div className="socialLogin d-flex justify-content-evenly pt-3">

                  <a href="https://bit.ly/welinkjobsapp" target="_blank">
                    <img src={SignInImages.playstore} alt="" width="130px" />
                  </a>
                  <a href="https://bit.ly/welinkjobs-iOS" target="_blank">
                    <img src={SignInImages.appstore} alt="" width="130px" />
                  </a>
                </div>
              </div>
              <div className="linksHelp">
                                <p><a href="/privacy-policy.html" target='_blank'>{t("Sidemenubar.Privacy Policy")} </a> | 
                                <a href="/terms-and-conditions.html" target='_blank'>
                                {t("Sidemenubar.Terms & Conditions")}</a></p>
                                <p className='d-flex'>{t("SignIn.Having Troubles")}? <a href="/faq.html" className='border-bottom me-3 ms-1' target='_blank'>
                                {t("SignIn.Get Help")}</a>
                                  <Dropdown className="language-dropdown">
                                                  <Dropdown.Toggle
                                                    id="language-toggle"
                                                    variant="link"
                                                    className="text-decoration-none p-0 d-flex align-items-center language-btn"
                                                    style={{transform:"none !important"}}
                                                  >
                                                    {/* <Globe size={18} className="me-1" /> */}
                                                  <TranslateIcon className="material-symbols-sharp me-3" 
                                                  //  style={{ color: "white", position: "relative", top: "1px" }}
                                                   style={{left: "20%", fill: "white"}}
                                                  />
                                                    {/* <span>{t("Language")}</span> */}
                                                  </Dropdown.Toggle>
                                
                                                  <Dropdown.Menu align="end">
                                                    <Dropdown.Item as="button" style={{width: "150px"}} onClick={() => changeLanguage("en")}>
                                                      <div className="d-flex justify-content-between align-items-center w-100">
                                                        <span>English</span>
                                                        {currentLang === "en" && (
                                                          <span style={{color: "#0d6efd", fontWeight: 600}}>✓</span>
                                                        )}
                                                      </div>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item as="button" style={{width: "150px"}} onClick={() => changeLanguage("hi")}>
                                                      <div className="d-flex justify-content-between align-items-center w-100">
                                                        <span>Hindi</span>
                                                        {currentLang === "hi" && (
                                                          <span style={{color: "#0d6efd", fontWeight: 600}}>✓</span>
                                                        )}
                                                      </div>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item as="button" style={{width: "150px"}} onClick={() => changeLanguage("ar")}>
                                                      <div className="d-flex justify-content-between align-items-center w-100">
                                                        <span>Arabic</span>
                                                        {currentLang === "ar" && (
                                                          <span style={{color: "#0d6efd", fontWeight: 600}}>✓</span>
                                                        )}
                                                      </div>
                                                    </Dropdown.Item>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                                 </p>
                            </div>

            </div>
          </div>
          <div className="col-lg-4 col-md-6 Login-Section">
            <div className="form-container pb-3">
              <p className="f-22 mb-2 text-center borderSignUp">
                {t("SignIn.New User")}? <Link to="/SignUp" className="">
                  {t("SignIn.Create an account")}
                </Link>
              </p>
              <Form onSubmit={handleSubmit} className="formBorder p-1">
                <h2 className="fw-bold text-center f-22 SigninHeading">
                  {t("SignIn.Sign in")}
                </h2>
                <FloatingLabelInput
                  id="email"
                  label={t("Manage Companies.Email Id")}
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="custom-input"
                />
                {errors.email && touched.email && (
                  <p className="form-error" style={{ color: "red" }}>
                    {errors.email}
                  </p>
                )}
                <div className="password-input border-signIn d-flex align-items-baseline">
                  <FloatingLabelInput
                    id="password"
                    label={t("SignIn.Password")}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <div
                    className="password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>
                {errors.password && touched.password && (
                  <p className="form-error" style={{ color: "red" }}>
                    {errors.password}
                  </p>
                )}
                <div className="signup">
                  <Link to="/ForgotPassword">{t("SignIn.Forgot Password")}</Link>
                  <button
                    type="submit"
                    className="mainBtn"
                    disabled={loading}

                  // disabled={!values.email || !values.password}
                  >
                    {loading === true ? `${t("SignIn.Loading")}` : `${t("SignIn.Sign in")}`}

                  </button>
                </div>
              </Form>
              <div className="divider">{t("SignIn.or")}</div>
              <div className="socialLogin d-flex justify-content-between gap-4 pt-2 pb-2">
                <button className="socialBtn" onClick={googleSignin}>
                  <img src={SignInImages.google} alt="google" />
                  <p>{t("SignIn.Signin with Google")}</p>
                </button>
                <button className="socialBtn" onClick={signInWithApple}>
                  <img src={SignInImages.apple} alt="google" width={20} />
                  <p>{t("SignIn.Signin with Apple")}</p>
                </button>
              </div>
              <div className="divider my-1">{t("SignIn.or")}</div>
              <div className="text-center">
                <button
                  type="submit"
                  className="mainBtn"
                  onClick={activateGuestMode}
                >
                  {t("SignIn.Explore as guest")}
                </button>
              </div>

              {/* <p className="f-22 mt-2 text-center borderSignUp">
              New User?{" "}
              <Link to="/SignUp" className="fw-bold">
                Create an account
              </Link>
            </p> */}
            </div>
          </div>
        </div>

        {/* <LeftNavigation data={data} /> */}

        <SuccessToast
          show={showToast && !!String(toastMessage || "").trim()}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />

        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />

        <ErrorToast
          show={showErrorToast}
          message={ErrorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />

        {showModal && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="setting-header d-flex justify-content-between align-items-center p-2">
                  <h6>Additional Details</h6>
                  {/* <span
                  className="material-symbols-sharp me-3 pointer"
                  onClick={handleModalClose}
                >
                  close
                </span> */}
                  <CloseSharpIcon
                    className="material-symbols-sharp me-3 pointer"
                    onClick={handleModalClose}
                  />
                </div>
                <Form>
                  <div className="row modal-p settings CreateCompany">
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        Email
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={originalemail}
                        onChange={(e) => setOriginalEmail(e.target.value)}
                      // invalid={display && email === ""}
                      />
                      {/* {display && !email ? (
          <span className="error_msg_lbl">Enter Email </span>
        ) : null} */}
                    </div>
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        FirstName
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      // invalid={display && firstName === ""}
                      />
                      {/* {display && !firstName ? (
          <span className="error_msg_lbl">Enter FirstName </span>
        ) : null} */}
                    </div>
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        LastName
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      // invalid={display && lastName === ""}
                      />
                      {/* {display && !lastName ? (
          <span className="error_msg_lbl">Enter LastName </span>
        ) : null} */}
                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="closebtn me-2"
                        onClick={handleModalClose}
                        style={{ width: "60px" }}
                      >
                        {t("User Profile.Close")}
                      </button>
                      <button
                        type="button"
                        className="mainBtn1"
                        // onClick={_registerWithApple}
                        style={{ width: "70px" }}
                      >
                        {t("User Profile.Submit")}
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
        {flag && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="p-2 pt-4 text-center">
                  <h4>Hi {User_Name},</h4>
                  <h6>
                    <span className="fw-bold signUpModal">
                      Verify account by OTP
                    </span>{" "}
                  </h6>
                  {/* <p>Registration data saved, check mail for verification OTP</p> */}
                  <p>{Response_Message}</p>
                </div>
                <Form
                  className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                  onSubmit={confimAcc === false ? 
                    ConfirmotpCheck :
                    otpCheck}
                  style={{ display: flag ? "block" : "none" }}
                >
                  <div className="mb-1 d-flex justify-content-center otp-input">
                    {/* <OTPInput
                    value={otp}
                    onChange={handleChangeOtp}
                    numInputs={6}
                  /> */}
                    <OtpInput
                      value={otp}
                      onChange={handleChangeOtp}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className="text-center mt-3">
                    {/* <Button color="" className="theme-bg" type="submit">
                 </Button> */}
                    <div className="countdown-text d-flex justify-content-center">
                      {seconds > 0 || minutes > 0 ? (
                        <p className="me-3">
                          Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </p>
                      ) : (
                        <p className="me-3">Didn't recieve code?</p>
                      )}

                      <span
                        style={{
                          color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                          pointerEvents: seconds > 0 || minutes > 0 ? "none" : "auto",
                          cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                        }}
                        onClick={confimAcc === false ? 
                          resendOTP :
                          Resend2FAOTP
                        }
                        className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                      >
                        Resend OTP
                      </span>
                    </div>
                    <button
                      type="submit"
                      className="mainBtn"
                      disabled={loadOTP || otp.length < 4}
                    >
                      {loadOTP ? "loading..." : "Verify OTP"}
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SignIn;
